module.exports = __webpack_public_path__ + "4f5b841c8f617888e0aa084686225197.svg";